import React from "react";
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";

interface SubNavigationProps {
  activeTab: string;
  onTabChange: (tab: string) => void;
  tabs: Array<{
    id: string;
    label: string;
  }>;
}

const subNavigationTabsListClassName =
  "h-9 w-[685px] items-stretch gap-1 rounded-lg bg-[#FBFAFF] px-1 py-1.5 text-foreground shadow-sm";
const subNavigationTabsTriggerClassName =
  "flex flex-1 items-center justify-center self-stretch rounded-md border border-transparent bg-transparent px-2 py-1 text-xs leading-none font-medium text-[#0A0A0A] shadow-none transition-colors hover:bg-[#EDE9FE]/40 data-[state=active]:border-[#C7BCFF] data-[state=active]:bg-[#F2F0FF] data-[state=active]:shadow-none";

export const SubNavigation: React.FC<SubNavigationProps> = ({
  activeTab,
  onTabChange,
  tabs,
}) => {
  return (
    <div className="flex items-center justify-center">
      <Tabs value={activeTab} onValueChange={onTabChange}>
        <TabsList className={subNavigationTabsListClassName}>
          {tabs.map((tab) => (
            <TabsTrigger
              key={tab.id}
              value={tab.id}
              className={subNavigationTabsTriggerClassName}
            >
              {tab.label}
            </TabsTrigger>
          ))}
        </TabsList>
      </Tabs>
    </div>
  );
};
